const I18NextHttpBackend = require("i18next-http-backend");
const env = process.env.NODE_ENV;
const isProd = env === "production";

console.log(`[i18n Config] NODE_ENV: ${env}, isProd: ${isProd}`);

module.exports = {
  i18n: {
    defaultLocale: "zh-TW",
    locales: ["zh-TW", "en", "jp"],
    react: { useSuspense: false },
    reloadOnPrerender: true,
    backend: {
      loadPath: `${
        isProd ? "https://www.udrive.city" : "http://localhost:3000"
      }/api/i18n/translations?lang={{lng}}`,
    },
  },
  debug: !isProd,
  ns: ["common"],
  serializeConfig: false,
  use: [I18NextHttpBackend],
};
